import "./AccountLogEmptyState.css";

const ROW_DELAYS = ["0.25s", "0.85s", "1.45s", "2.05s", "2.65s", "3.05s"];

export default function AccountLogEmptyState() {
    return (
        <div className="relative h-80 overflow-hidden rounded-md border border-gray-200 bg-white">
            <div className="absolute inset-0 flex flex-col gap-4 p-5">
                {ROW_DELAYS.map((delay) => (
                    <div key={delay} className="acc-log-row flex items-center gap-3" style={{ animationDelay: delay }}>
                        <span className="h-2 w-14 rounded bg-gray-200" />
                        <span className="h-2 w-20 rounded bg-gray-100" />
                        <span className="h-2 flex-1 rounded bg-gray-100" />
                        <span className="h-2 w-7 rounded bg-gray-100" />
                    </div>
                ))}
            </div>
            <div
                className="acc-log-sweep pointer-events-none absolute left-0 right-0 h-16"
                style={{ background: "linear-gradient(180deg, rgba(37,99,235,0) 0%, rgba(37,99,235,.09) 78%, rgba(37,99,235,0) 100%)" }}
            >
                <div
                    className="absolute inset-x-0 bottom-0 h-px"
                    style={{ background: "linear-gradient(90deg, rgba(37,99,235,0), rgba(37,99,235,.85) 20%, rgba(37,99,235,.85) 80%, rgba(37,99,235,0))" }}
                />
            </div>
            <div
                className="absolute inset-0 flex flex-col items-center justify-center gap-2.5 px-10 text-center"
                style={{ background: "radial-gradient(circle at 50% 50%, #fff 0%, rgba(255,255,255,.95) 52%, rgba(255,255,255,0) 80%)" }}
            >
                <span className="font-mono text-[11px] tracking-widest text-blue-600">0 / 0 RECORDS</span>
                <span className="text-base font-semibold text-gray-900">아직 기록된 로그가 없습니다.</span>
                <span className="text-sm leading-relaxed text-gray-500">신규 계정입니다. 첫 활동이 발생하면 이 목록에 실시간으로 표시됩니다.</span>
            </div>
        </div>
    );
}
